<template>
    <div>
        <div class="form-group">
            <label v-if="label">{{label}}</label>
            <div class="input-group">
                <span class="input-group-prepend">
                    <span class="input-group-text"><i class="icon-calendar22"></i></span>
                </span>
                <input id="period-input" readonly class="form-control" v-model="range" @click="controlPickerCard" data-toggle="modal" data-target="#exampleModal">
            </div>
        </div>
        <div id="date-card" class="card datepicker-card" v-show="isCardOpen" style="position: absolute" >
            <div class="card-body">
                <ul class="nav nav-pills" id="myTab" role="tablist" style="position: relative; top: -1rem;">
                    <li class="nav-item" role="presentation">
                        <a
                            class="nav-link active"
                            id="relative-tab"
                            data-toggle="tab"
                            href="#relative"
                            role="tab"
                            aria-controls="relative"
                            aria-selected="true"
                            @click="openRelativePicker"
                        >
                            relative
                        </a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a
                            class="nav-link"
                            id="absolute-tab"
                            data-toggle="tab"
                            href="#absolute"
                            role="tab"
                            aria-controls="absolute"
                            aria-selected="false"
                            @click="openAbsolutePicker"
                        >
                            absolute
                        </a>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="relative" role="tabpanel" aria-labelledby="relative-tab">
                        <div style="display: flex">
                            <basic-input :type="'number'" v-model="relativeTimeValue" min="1"/>
                            <select2 :options="relativeUnitOptions" v-model="relativeUnitValue" rule="required"/>
                            <button class="form-group btn" @click="setRelativeRange">apply</button>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="absolute" role="tabpanel" aria-labelledby="absolute-tab">
                        <div id="absolute-picker" >
                            <input  class="form-control" ref="dateRange"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from "@/components/form/select/Select2";
    import BasicInput from "@/components/form/input/BasicInput";
    export default {
        components: {BasicInput, Select2},
        name: "relative-absolute-date-range-picker",
        props: {
            label: {
                type: String,
            },
            value: {
            }
        },
        data() {
            return {
                isInit: false, // 초기화 확인용 일회용 변수
                periodType: this.$const.PERIOD_TYPE.RELATIVE,
                range:null,
                isCardOpen: false, // true: date picker card open
                relativeTimeValue: 1,
                relativeUnitValue: 'd',
                relativeUnitOptions: [
                    {text:'Minutes ago', value: 'm'},
                    {text:'Hours ago', value: 'h'},
                    {text:'Days ago', value: 'd'},
                    {text:'Weeks ago', value: 'w'},
                    {text:'Months ago', value: 'M'},
                ],/**/
            }
        },
        mounted() {
            // absolute tab에 date range picker 적용
            this.applyCalendar()

            // default 1 days ago로 period 설정 -> Send Log 페이지 진입시 1 days ago로 search
            this.setRelativeRange()
            this.isInit = true

            // date range picker card outside click -> close card
            const vue = this
            $(document).on('click', function(e) {
                const target = e.target
                const periodInputId = 'period-input'
                const card = $('#date-card')
                if(vue.isCardOpen && target.id !== periodInputId && !card.is(target) && card.has(target).length === 0) {
                    vue.closePickerCard()
                }
            })
        },
        computed: {
            relativeUnitText: function () {
                return this.relativeUnitOptions.find(item => item.value === this.relativeUnitValue).text.split(' ')[0].toLowerCase()
            },
            isRelative: function () {
                return this.periodType === this.$const.PERIOD_TYPE.RELATIVE
            }
        },
        watch: {
            'range': function(val) {
                if(!val) this.$emit('input',null)
            },
            'value': function(val) {
                if(val) {
                    if(this.periodType === this.$const.PERIOD_TYPE.ABSOLUTE) {
                        this.range = this.$moment.unix(val.start).format('MMM DD, YYYY') + ' - ' + this.$moment.unix(val.end).format('MMM DD, YYYY')
                    } else {
                        this.range = `Last ${this.relativeTimeValue} ${this.relativeUnitText}`
                    }
                }
            },
            'periodType': function (val) {
                // Tab 바뀔 때 캘린더 오픈
                if(val === this.$const.PERIOD_TYPE.ABSOLUTE) {
                    this.openCalendars()
                }
            },
            'isCardOpen': function (val) {
                // Period input 클릭되어 카드 오픈될 때 absolute Tab이면 캘린더 오픈
                if(!!val && this.periodType === this.$const.PERIOD_TYPE.ABSOLUTE) {
                    this.openCalendars()
                }
            }
        },
        methods: {
            controlPickerCard: function () {
                this.isCardOpen = !this.isCardOpen
            },
            closePickerCard: function () {
                this.isCardOpen = false
            },
            openAbsolutePicker: function () {
                this.periodType = this.$const.PERIOD_TYPE.ABSOLUTE
            },
            openRelativePicker: function () {
                this.periodType = this.$const.PERIOD_TYPE.RELATIVE
            },
            openCalendars:  function () {
                // alwaysShowCalendars 옵션 설정이 안돼서 이벤트 강제 발생
                $(this.$refs.dateRange).trigger('click')
                // endDate까지 선택하면 캘린더 위치가 변경되어 !important 지정
                $('.daterangepicker').css('top', '!important')
                // div 크기가 작아서 캘린더가 세로로 출력되어 지정
                $('.daterangepicker').css('width', '50rem')
            },
            setRelativeRange: function() {
                this.periodType = this.$const.PERIOD_TYPE.RELATIVE
                const now = this.$moment()
                const end = now.unix()
                const start = now.subtract(this.relativeTimeValue, this.relativeUnitValue).unix()
                this.$emit('input', {start,end})
                this.closePickerCard()

                // init absolute period
                if(this.isInit) {
                    this.applyCalendar()
                }
            },
            applyCalendar: function() {
                let vue = this
                let dateRange = this.$refs.dateRange
                $(this.$refs.dateRange).daterangepicker({
                    applyClass: 'bg-slate-600',
                    cancelClass: 'btn-light',
                    autoUpdateInput: false,
                    parentEl: '#absolute-picker',
                    alwaysShowCalendars: true
                },(start,end,label)=>{
                    this.periodType = this.$const.PERIOD_TYPE.ABSOLUTE
                    vue.$emit('input',{start:start.unix(),end:end.unix()})

                    // init relative period
                    vue.relativeTimeValue = '1'
                    vue.relativeUnitValue = 'd'

                });
                $(this.$refs.dateRange).on('hide.daterangepicker',function(ev, picker) {
                    vue.closePickerCard()
                })
            }
        }

    }
</script>

<style scoped>
.datepicker-card {
    position: absolute;
    z-index: 999;
}

</style>
